import { Box, Button, HStack, Text } from '@chakra-ui/react';
import { FiRefreshCw } from 'react-icons/fi'

/** Blocking notice (L10): the schedule changed on the server since this editor loaded, so the
 *  save was rejected. The user's edits are kept in the editor but Save is disabled — they must
 *  reload (discarding their unsaved edits) to get the latest, then re-apply. */
export function ScheduleConflictBanner({ onReload }: { onReload: () => void }) {
  return (
    <Box bg="red.50" borderWidth="1px" borderColor="red.300" borderRadius="md" p={3} mb={3}>
      <HStack justify="space-between" gap={3} flexWrap="wrap">
        <Text fontSize="sm" color="red.900">
          Someone else changed this schedule since you opened it. Your changes aren&apos;t saved.
          Reload to get their version — this discards your unsaved edits.
        </Text>
        <Button
          size="sm"
          colorPalette="red"
          minH="44px"
          onClick={() => {
            if (window.confirm('Discard your unsaved edits and load the latest schedule?')) onReload()
          }}>
          <FiRefreshCw />Reload
        </Button>
      </HStack>
    </Box>
  );
}
